// extracted by mini-css-extract-plugin
module.exports = {"root":"home_root__vQMmr","content":"home_content__yP9VY","form":"home_form__wmbGr"};